<template>
  <v-data-table fixed-header disable-pagination hide-default-footer :headers="headers" :items="items" no-data-text="Sem dados">
    <template v-slot:item="{ item, index }">
      <tr>
        <td>
          {{ item.name }}
        </td>
        <td>
          {{ item.sku }}
        </td>
        <td v-if="variant !== 'out-club-products'">
          <span>{{ item.days === 1 ? '1 dia' : `${item.days} dias` }}</span>
        </td>
        <td v-if="variant !== 'out-club-products'">
          <span
            :class="{
              'color-best': item.incrementalRevenue > 0,
              'color-neutral': item.incrementalRevenue === 0,
              'color-worst': item.incrementalRevenue < 0,
            }"
            >{{ getNegative(item.incrementalRevenue) }}{{ getIncrementalRevenue(item.incrementalRevenue) | localeString(2) | currency }}</span
          >
        </td>
        <td>
          <span>{{ item.revenue | localeString(2) | currency }}</span>
        </td>
        <td>
          <span
            :class="{
              'color-best': item.increase > 0,
              'color-neutral': item.increase === 0,
              'color-worst': item.increase < 0,
            }"
          >
            {{ item.increase > 0 ? '+' : '' }}
            {{ (item.increase * 100) | localeString(0) }} %
          </span>
        </td>
        <td v-if="variant !== 'out-club-products'">
          <span>{{ item.firstBuy | localeString | hifen }}</span>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'DreProductsTable',
  props: {
    variant: {
      type: String,
      default: 'offer-products',
      validator: (value) => ['offer-products', 'out-club-products'],
    },
    products: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    items() {
      return this.products.map((item) => {
        return {
          sku: item?.product?.sku,
          name: item?.product?.name,
          image: item?.product?.image,
          days: item?.metrics?.daysOnOffer?.quantity,
          revenue: item?.metrics?.revenue,
          increase: item?.metrics?.uplift,
          firstBuy: item?.metrics?.firstBuy?.quantity,
          incrementalRevenue: item?.metrics?.incrementalRevenue,
        }
      })
    },
    headers() {
      return [
        {
          text: 'Produto',
          value: 'name',
          width: '224px',
          sortable: false,
        },
        {
          text: 'SKU',
          value: 'sku',
          width: '56px',
          sortable: false,
        },
        ...(this.variant === 'offer-products'
          ? [
              {
                text: 'Dias em oferta',
                value: 'days',
                width: '90px',
                sortable: false,
              },
              {
                text: 'Fat. incremental',
                value: 'incrementalRevenue',
                width: '128px',
                sortable: false,
              },
            ]
          : []),
        {
          text: 'Faturamento',
          value: 'revenue',
          width: '118px',
          sortable: false,
        },
        {
          text: 'Aumento das vendas',
          value: 'increase',
          width: '114px',
          sortable: false,
        },
        ...(this.variant === 'offer-products'
          ? [
              {
                text: 'Primeiras compras',
                value: 'firstBuy',
                width: '82px',
                sortable: false,
              },
            ]
          : []),
      ]
    },
  },
  methods: {
    getIncrementalRevenue(incrementalRevenue) {
      return Math.abs(incrementalRevenue)
    },
    getNegative(value) {
      return value < 0 ? '-' : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.color-best {
  color: $verde-0;
}

.color-worst {
  color: $vermelho-0;
}

.color-neutral {
  color: $cinza-0;
}
::v-deep th {
  color: $cinza-d20 !important;
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  border-left: 1px solid #eee;
}
::v-deep thead th {
  border-bottom: 1px solid #eee !important;
}

::v-deep .v-data-table-header tr,
::v-deep .v-data-table-header th {
  background: #fff !important;
  border-top: 1px solid #fff !important;
}

::v-deep tbody {
  td {
    color: $cinza-d10;
    font-size: 14px;
    line-height: 1;
    border-left: 1px solid #eee;
  }
}
::v-deep tbody {
  td:first-child {
    border-left: none;
  }
}
::v-deep th:first-child {
  border-left: none;
}
</style>
